var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"preview"},[_c('ds-placeholder',{staticClass:"empty-state",attrs:{"rows":_vm.placeholderRows}})],1):_c('div',{staticClass:"preview",domProps:{"innerHTML":_vm._s(_vm.signature)}})}
var staticRenderFns = []

export { render, staticRenderFns }